import { render, staticRenderFns } from "./detial.vue?vue&type=template&id=263021f0&scoped=true&"
import script from "./detial.vue?vue&type=script&lang=js&"
export * from "./detial.vue?vue&type=script&lang=js&"
import style0 from "./detial.vue?vue&type=style&index=0&id=263021f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263021f0",
  null
  
)

export default component.exports